import pivotTable from "./pivotTable";
import luckysheetFreezen from "./freezen";
import menuButton from "./menuButton";
import conditionformat from "./conditionformat";
import alternateformat from "./alternateformat";
import cellDatePickerCtrl from "./cellDatePickerCtrl";
import dataVerificationCtrl from "./dataVerificationCtrl";
import { checkProtectionLocked, checkProtectionCellHidden } from "./protection";
import { chatatABC } from "../utils/util";
import { isEditMode } from "../global/validate";
import { getcellvalue, getFontStyleByCell, getInlineStringStyle } from "../global/getdata";
import { valueShowEs } from "../global/format";
import { getAutoWrapEditSource } from "../global/fixedWrap";
import formula from "../global/formula";
import { luckysheetRangeLast } from "../global/cursorPos";
import cleargridelement from "../global/cleargridelement";
import { isInlineStringCell } from "./inlineString";
import Store from "../store";
import server from "./server";
import method from "../global/method";
import { cellImageCtrl } from "./cellImageCtrl";
import { cellProtectionCtrl } from "./cellProtection";
import remoteSelect from "./remoteSelect";
import tooltip from "../global/tooltip";

const INPUT_BOX_HORIZONTAL_CHROME = 8;
const INPUT_BOX_VERTICAL_CHROME = 4;

function getElementPageRect($element) {
    const element = $element.get(0);
    if (element == null) {
        return null;
    }

    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    return {
        left: rect.left + scrollLeft,
        right: rect.right + scrollLeft,
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop,
    };
}

function getHorizontalEditorBounds(containerOffset) {
    const $canvas = $("#luckysheetTableContent");
    const canvasOffset = $canvas.offset();
    const canvasLeft = canvasOffset == null ? containerOffset.left : canvasOffset.left;
    const canvasWidth = $canvas.width() || Store.luckysheetTableContentHW[0] || $("#" + Store.container).width();

    return {
        left: canvasLeft + Store.rowHeaderWidth,
        right: canvasLeft + canvasWidth,
    };
}

function getCellHorizontalRange(col, col_pre, col_index, containerOffset, scrollLeft) {
    let horizontalScroll = scrollLeft;
    if (luckysheetFreezen.freezenverticaldata != null && col_index <= luckysheetFreezen.freezenverticaldata[1]) {
        horizontalScroll = 0;
    }

    const left = col_pre + containerOffset.left + Store.rowHeaderWidth - horizontalScroll;
    return { left: left, right: left + col - col_pre + 1 };
}

function getHorizontalInputLayout(alignment, cellRange, editorBounds) {
    const minWidth = Math.max(0, cellRange.right - cellRange.left - INPUT_BOX_HORIZONTAL_CHROME);
    let anchor;
    let maxWidth;

    if (alignment == "right") {
        anchor = Math.min(editorBounds.right, Math.max(editorBounds.left, cellRange.right));
        maxWidth = anchor - editorBounds.left - INPUT_BOX_HORIZONTAL_CHROME;
    } else if (alignment == "center") {
        anchor = Math.min(editorBounds.right, Math.max(editorBounds.left, (cellRange.left + cellRange.right) / 2));
        maxWidth = editorBounds.right - editorBounds.left - INPUT_BOX_HORIZONTAL_CHROME;
    } else {
        anchor = Math.min(editorBounds.right, Math.max(editorBounds.left, cellRange.left - 2));
        maxWidth = editorBounds.right - anchor - INPUT_BOX_HORIZONTAL_CHROME;
    }

    maxWidth = Math.max(0, maxWidth);
    return {
        alignment: alignment,
        anchor: anchor,
        bounds: editorBounds,
        "min-width": Math.min(minWidth, maxWidth),
        "max-width": maxWidth,
    };
}

function applyHorizontalInputLayout(inputPosition, layout, measuredWidth) {
    const minWidth = layout["min-width"];
    const maxWidth = layout["max-width"];
    const width = Math.min(maxWidth, Math.max(minWidth, measuredWidth || 0));
    const outerWidth = width + INPUT_BOX_HORIZONTAL_CHROME;
    let left = layout.anchor;

    if (layout.alignment == "right") {
        left = layout.anchor - outerWidth;
    } else if (layout.alignment == "center") {
        left = layout.anchor - outerWidth / 2;
    }

    inputPosition.left = Math.min(layout.bounds.right - outerWidth, Math.max(layout.bounds.left, left));
    inputPosition.right = "auto";
    inputPosition["min-width"] = minWidth;
    inputPosition["max-width"] = maxWidth;
}

function getVerticalEditorBounds(containerOffset) {
    const $canvas = $("#luckysheetTableContent");
    const canvasRect = getElementPageRect($canvas);
    const cellMainRect = getElementPageRect($("#luckysheet-cell-main"));
    const scrollbarRect = getElementPageRect($("#luckysheet-scrollbar-x"));
    const canvasTop = canvasRect == null ? containerOffset.top : canvasRect.top;
    const canvasHeight = $canvas.height() || Store.luckysheetTableContentHW[1] || $("#" + Store.container).height();
    const dataTop = canvasTop + Store.columnHeaderHeight;
    const dataBottom = canvasRect == null ? canvasTop + canvasHeight : canvasRect.bottom;
    const bottomCandidates = [dataBottom];

    if (cellMainRect != null) {
        bottomCandidates.push(cellMainRect.bottom);
    }

    if (scrollbarRect != null) {
        bottomCandidates.push(scrollbarRect.top);
    }

    return {
        top: cellMainRect == null ? dataTop : Math.max(dataTop, cellMainRect.top),
        bottom: Math.min.apply(null, bottomCandidates),
    };
}

function getCellVerticalRange(row, row_pre, row_index, editorBounds, scrollTop) {
    let verticalScroll = scrollTop;
    if (luckysheetFreezen.freezenhorizontaldata != null && row_index <= luckysheetFreezen.freezenhorizontaldata[1]) {
        verticalScroll = 0;
    }

    const top = row_pre + editorBounds.top - verticalScroll;
    return { top: top, bottom: top + row - row_pre + 1 };
}

function getVerticalInputLayout(alignment, cellRange, editorBounds) {
    const minHeight = Math.max(0, cellRange.bottom - cellRange.top - INPUT_BOX_VERTICAL_CHROME);
    let anchor;
    let maxHeight;

    if (alignment == "bottom") {
        anchor = Math.min(editorBounds.bottom, Math.max(editorBounds.top, cellRange.bottom));
        maxHeight = anchor - editorBounds.top - INPUT_BOX_VERTICAL_CHROME;
    } else if (alignment == "center") {
        anchor = Math.min(editorBounds.bottom, Math.max(editorBounds.top, (cellRange.top + cellRange.bottom) / 2));
        maxHeight = editorBounds.bottom - editorBounds.top - INPUT_BOX_VERTICAL_CHROME;
    } else {
        anchor = Math.min(editorBounds.bottom, Math.max(editorBounds.top, cellRange.top - 2));
        maxHeight = editorBounds.bottom - anchor - INPUT_BOX_VERTICAL_CHROME;
    }

    maxHeight = Math.max(0, maxHeight);
    return {
        alignment: alignment,
        anchor: anchor,
        bounds: editorBounds,
        "min-height": Math.min(minHeight, maxHeight),
        "max-height": maxHeight,
    };
}

function applyVerticalInputLayout(inputPosition, layout, measuredHeight) {
    const minHeight = layout["min-height"];
    const maxHeight = layout["max-height"];
    const height = Math.min(maxHeight, Math.max(minHeight, measuredHeight || 0));
    const outerHeight = height + INPUT_BOX_VERTICAL_CHROME;
    let top = layout.anchor;

    if (layout.alignment == "bottom") {
        top = layout.anchor - outerHeight;
    } else if (layout.alignment == "center") {
        top = layout.anchor - outerHeight / 2;
    }

    inputPosition.top = Math.min(layout.bounds.bottom - outerHeight, Math.max(layout.bounds.top, top));
    inputPosition.bottom = "auto";
    inputPosition.height = height;
    inputPosition["min-height"] = minHeight;
    inputPosition["max-height"] = maxHeight;
}

function getMeasuredInputHeight() {
    const $inputBox = $("#luckysheet-input-box");
    const richTextEditor = $("#luckysheet-rich-text-editor").get(0);

    $inputBox.css("height", "auto");

    const contentHeight = richTextEditor == null ? 0 : richTextEditor.scrollHeight * Store.zoomRatio;
    return Math.max($inputBox.height() || 0, contentHeight);
}

export function luckysheetupdateCell(row_index1, col_index1, d, cover, isnotfocus) {
    // 这里才是单元格编辑的核心函数

    if (!checkProtectionLocked(row_index1, col_index1, Store.currentSheetIndex)) {
        $("#luckysheet-functionbox-cell").blur();
        return;
    }

    if (isEditMode() || Store.allowEdit === false) {
        //此模式下禁用单元格编辑
        return;
    }

    console.log("这里才是单元格编辑的核心函数");
    // 判断当前 row  col 是否为 单元格图片格式
    if (cellImageCtrl.isCellImage(row_index1, col_index1)) {
        cellImageCtrl.previewCellImage(row_index1, col_index1);
        return;
    }

    // 判断当前 row col 是否为保护单元格
    if (!cellProtectionCtrl.isEditable(row_index1, col_index1)) {
        tooltip.info("温馨提示", "当前单元格已被保护，不允许编辑！");
        return;
    }

    // 判断当前单元格是否需要初始化远程搜索控件
    remoteSelect.checkCellNeedRemoteSelect(row_index1, col_index1);

    // 钩子函数
    if (!method.createHookFunction("cellEditBefore", Store.luckysheet_select_save)) {
        return;
    }

    // 编辑单元格时发送指令到后台，通知其他单元格更新为“正在输入”状态
    server.saveParam("mv", Store.currentSheetIndex, { op: "enterEdit", range: Store.luckysheet_select_save });

    //数据验证
    if (dataVerificationCtrl.dataVerification != null && dataVerificationCtrl.dataVerification[row_index1 + "_" + col_index1] != null) {
        let dataVerificationItem = dataVerificationCtrl.dataVerification[row_index1 + "_" + col_index1];
        if (dataVerificationItem.type == "dropdown") {
            dataVerificationCtrl.dropdownListShow();
        } else if (dataVerificationItem.type == "checkbox") {
            return;
        }
    }

    let size = getColumnAndRowSize(row_index1, col_index1, d);
    let row = size.row,
        row_pre = size.row_pre,
        col = size.col,
        col_pre = size.col_pre,
        row_index = size.row_index,
        col_index = size.col_index;

    if ($("#luckysheet-dropCell-icon").is(":visible")) {
        $("#luckysheet-dropCell-icon").remove();
    }

    let winH = $(window).height();
    let container_offset = $("#" + Store.container).offset();
    let scrollLeft = $("#luckysheet-cell-main").scrollLeft();
    let scrollTop = $("#luckysheet-cell-main").scrollTop();

    if (pivotTable.isPivotRange(row_index, col_index)) {
        return;
    }

    let left = col_pre + container_offset.left + Store.rowHeaderWidth - scrollLeft - 2;
    if (luckysheetFreezen.freezenverticaldata != null && col_index1 <= luckysheetFreezen.freezenverticaldata[1]) {
        left = col_pre + container_offset.left + Store.rowHeaderWidth - 2;
    }

    let top = row_pre + container_offset.top + Store.infobarHeight + Store.toolbarHeight + Store.calculatebarHeight + Store.columnHeaderHeight - scrollTop - 2;
    if (luckysheetFreezen.freezenhorizontaldata != null && row_index1 <= luckysheetFreezen.freezenhorizontaldata[1]) {
        top = row_pre + container_offset.top + Store.infobarHeight + Store.toolbarHeight + Store.calculatebarHeight + Store.columnHeaderHeight - 2;
    }

    let input_postition = {
        "min-height": row - row_pre + 1 - 4,
        "max-height":
            winH +
            scrollTop -
            row_pre -
            20 -
            15 -
            Store.toolbarHeight -
            Store.infobarHeight -
            Store.calculatebarHeight -
            Store.sheetBarHeight -
            Store.statisticBarHeight,
        left: left,
        top: top,
    };
    let horizontalAlignment = "left";
    let verticalAlignment = "top";
    const horizontalEditorBounds = getHorizontalEditorBounds(container_offset);
    const cellHorizontalRange = getCellHorizontalRange(col, col_pre, col_index, container_offset, scrollLeft);
    const verticalEditorBounds = getVerticalEditorBounds(container_offset);
    const cellVerticalRange = getCellVerticalRange(row, row_pre, row_index, verticalEditorBounds, scrollTop);

    let inputContentScale = {
        transform: "scale(" + Store.zoomRatio + ")",
        "transform-origin": "left top",
        width: 100 / Store.zoomRatio + "%",
        height: 100 / Store.zoomRatio + "%",
    };
	let editorTextStyle = "";

    Store.luckysheetCellUpdate = [row_index, col_index];
    if (!isnotfocus) {
        $("#luckysheet-rich-text-editor").focus().select();
    }

    $("#luckysheet-input-box")
        .removeAttr("style data-luckysheet-manual-line-break")
        .css({
            "background-color": "rgb(255, 255, 255)",
            padding: "0px 2px",
            "font-size": `${Store.defaultFontSize}pt`,
            right: "auto",
            "overflow-x": "auto",
            "overflow-y": "auto",
            "box-sizing": "initial",
            display: "flex",
        });
	$("#luckysheet-rich-text-editor").removeAttr("style");

    if (luckysheetFreezen.freezenverticaldata != null || luckysheetFreezen.freezenhorizontaldata != null) {
        $("#luckysheet-input-box").css("z-index", 10002);
    }

    $("#luckysheet-input-box-index")
        .html(chatatABC(col_index) + (row_index + 1))
        .hide();
    $("#luckysheet-wa-functionbox-cancel, #luckysheet-wa-functionbox-confirm").addClass("luckysheet-wa-calculate-active");

    let value = "";

    if (d[row_index] != null && d[row_index][col_index] != null) {
        let cell = d[row_index][col_index];
		let editorStyleCell = isInlineStringCell(cell) && cell.ct.s.length > 0 ? cell.ct.s[0] : cell;
		editorTextStyle = getFontStyleByCell(editorStyleCell) || getFontStyleByCell(cell) || "";
        let htValue = cell["ht"];
        let leftOrigin = "left";
        if (htValue == "0") {
            //0 center, 1 left, 2 right
            input_postition = {
                "min-height": row - row_pre + 1 - 4,
                // "transform":"scale("+ Store.zoomRatio +")",
                // "transform-origin":"center top",
                "max-height":
                    winH +
                    scrollTop -
                    row_pre -
                    20 -
                    15 -
                    Store.toolbarHeight -
                    Store.infobarHeight -
                    Store.calculatebarHeight -
                    Store.sheetBarHeight -
                    Store.statisticBarHeight,
                left: col_pre + container_offset.left + Store.rowHeaderWidth - scrollLeft - 2,
                top:
                    row_pre +
                    container_offset.top +
                    Store.infobarHeight +
                    Store.toolbarHeight +
                    Store.calculatebarHeight +
                    Store.columnHeaderHeight -
                    scrollTop -
                    2,
            };
            horizontalAlignment = "center";

            if (Store.zoomRatio < 1) {
                leftOrigin = "center";
            }

        } else if (htValue == "2") {
            input_postition = {
                "min-height": row - row_pre + 1 - 4,
                // "transform":"scale("+ Store.zoomRatio +")",
                // "transform-origin":"right top",
                "max-height":
                    winH +
                    scrollTop -
                    row_pre -
                    20 -
                    15 -
                    Store.toolbarHeight -
                    Store.infobarHeight -
                    Store.calculatebarHeight -
                    Store.sheetBarHeight -
                    Store.statisticBarHeight,
                top:
                    row_pre +
                    container_offset.top +
                    Store.infobarHeight +
                    Store.toolbarHeight +
                    Store.calculatebarHeight +
                    Store.columnHeaderHeight -
                    scrollTop -
                    2,
            };
            horizontalAlignment = "right";

            if (Store.zoomRatio < 1) {
                leftOrigin = "right";
            }
        }

        if (cell["vt"] == "0") {
            verticalAlignment = "center";
        } else if (cell["vt"] == "2") {
            verticalAlignment = "bottom";
        }

        inputContentScale["transform-origin"] = leftOrigin + " top";

        if (!cover) {
            if (isInlineStringCell(cell)) {
                value = getInlineStringStyle(row_index, col_index, d);
            } else if (cell.f != null) {
                value = getcellvalue(row_index, col_index, d, "f");
            } else {
                let autoWrapEditSource = getAutoWrapEditSource(cell);
                value = autoWrapEditSource == null ? valueShowEs(row_index, col_index, d) : autoWrapEditSource;
                if (cell.qp == "1") {
                    value = value ? "" + value : value;
                }
            }
        }

        let style = menuButton.getStyleByCell(d, row_index, col_index);
        style = $("#luckysheet-input-box").get(0).style.cssText + style;

        $("#luckysheet-input-box").get(0).style.cssText = style;
        if ($("#luckysheet-input-box").get(0).style.backgroundColor == "rgba(0, 0, 0, 0)") {
            $("#luckysheet-input-box").get(0).style.background = "rgb(255,255,255)";
        }
    } else {
        //交替颜色
        let af_compute = alternateformat.getComputeMap();
        var checksAF = alternateformat.checksAF(row_index, col_index, af_compute);

        //条件格式
        var cf_compute = conditionformat.getComputeMap();
        var checksCF = conditionformat.checksCF(row_index, col_index, cf_compute);

        if (checksCF != null && checksCF["cellColor"] != null) {
            $("#luckysheet-input-box").get(0).style.background = checksCF["cellColor"];
        } else if (checksAF != null) {
            $("#luckysheet-input-box").get(0).style.background = checksAF[1];
        }
    }

    const horizontalInputLayout = getHorizontalInputLayout(horizontalAlignment, cellHorizontalRange, horizontalEditorBounds);
    const verticalInputLayout = getVerticalInputLayout(verticalAlignment, cellVerticalRange, verticalEditorBounds);
    input_postition["min-width"] = horizontalInputLayout["min-width"];
    input_postition["max-width"] = horizontalInputLayout["max-width"];
    input_postition["min-height"] = verticalInputLayout["min-height"];
    input_postition["max-height"] = verticalInputLayout["max-height"];

    if (input_postition["min-height"] > input_postition["max-height"]) {
        input_postition["min-height"] = input_postition["max-height"];
    }

    if (input_postition["min-width"] > input_postition["max-width"]) {
        input_postition["min-width"] = input_postition["max-width"];
    }

    // if((value == null || value.toString() == "") && !cover){
    //     value = "<br/>";
    // }
    value = formula.xssDeal(value);
    if (
        !checkProtectionCellHidden(row_index, col_index, Store.currentSheetIndex) &&
        value.length > 0 &&
        value.substr(0, 63) == '<span dir="auto" class="luckysheet-formula-text-color">=</span>'
    ) {
        $("#luckysheet-rich-text-editor").html("");
    } else {
        value = formula.ltGtSignDeal(value);
        $("#luckysheet-rich-text-editor").html(value);
        if (!isnotfocus) {
            luckysheetRangeLast($("#luckysheet-rich-text-editor")[0]);
        }
    }

	$("#luckysheet-rich-text-editor").get(0).style.cssText = editorTextStyle;
    $("#luckysheet-rich-text-editor").css(inputContentScale);
    applyHorizontalInputLayout(input_postition, horizontalInputLayout, $("#luckysheet-input-box").width());
    applyVerticalInputLayout(input_postition, verticalInputLayout, getMeasuredInputHeight());

    $("#luckysheet-input-box").css(input_postition);
    $("#luckysheet-rich-text-editor")
        .off("input.luckysheetInputLayout")
        .on("input.luckysheetInputLayout", function () {
            setCenterInputPosition(Store.luckysheetCellUpdate[0], Store.luckysheetCellUpdate[1], Store.flowdata);
        });

    //日期
    if (d[row_index1][col_index1] && d[row_index1][col_index1].ct && d[row_index1][col_index1].ct.t == "d") {
        cellDatePickerCtrl.cellFocus(row_index1, col_index1, d[row_index1][col_index1]);
    }

    formula.rangetosheet = Store.currentSheetIndex;
    formula.createRangeHightlight();
    formula.rangeResizeTo = $("#luckysheet-rich-text-editor");
    cleargridelement();
}

export function setCenterInputPosition(row_index, col_index, d) {
    if (row_index == null || col_index == null) {
        return;
    }
    let cell = d[row_index][col_index];
    if (cell == null) {
        return;
    }
    let htValue = cell["ht"];
    let vtValue = cell["vt"];
    let horizontalAlignment = htValue == "0" ? "center" : htValue == "2" ? "right" : "left";
    let verticalAlignment = vtValue == "0" ? "center" : vtValue == "2" ? "bottom" : "top";

    let size = getColumnAndRowSize(row_index, col_index, d);
    let row = size.row,
        row_pre = size.row_pre,
        edit_row_index = size.row_index,
        col = size.col,
        col_pre = size.col_pre,
        edit_col_index = size.col_index;

    let container_offset = $("#" + Store.container).offset();
    let scrollLeft = $("#luckysheet-cell-main").scrollLeft();
    let scrollTop = $("#luckysheet-cell-main").scrollTop();
    const horizontalEditorBounds = getHorizontalEditorBounds(container_offset);
    const cellHorizontalRange = getCellHorizontalRange(col, col_pre, edit_col_index, container_offset, scrollLeft);
    const horizontalInputLayout = getHorizontalInputLayout(horizontalAlignment, cellHorizontalRange, horizontalEditorBounds);
    const verticalEditorBounds = getVerticalEditorBounds(container_offset);
    const cellVerticalRange = getCellVerticalRange(row, row_pre, edit_row_index, verticalEditorBounds, scrollTop);
    const verticalInputLayout = getVerticalInputLayout(verticalAlignment, cellVerticalRange, verticalEditorBounds);
    let input_postition = {};

    applyHorizontalInputLayout(input_postition, horizontalInputLayout, $("#luckysheet-input-box").width());
    applyVerticalInputLayout(input_postition, verticalInputLayout, getMeasuredInputHeight());

    $("#luckysheet-input-box").css(input_postition);
}

export function getColumnAndRowSize(row_index, col_index, d) {
    let row = Store.visibledatarow[row_index],
        row_pre = row_index - 1 == -1 ? 0 : Store.visibledatarow[row_index - 1];
    let col = Store.visibledatacolumn[col_index],
        col_pre = col_index - 1 == -1 ? 0 : Store.visibledatacolumn[col_index - 1];

    if (d == null) {
        d = Store.flowdata;
    }

    let margeset = menuButton.mergeborer(d, row_index, col_index);
    if (!!margeset) {
        row = margeset.row[1];
        row_pre = margeset.row[0];
        row_index = margeset.row[2];
        col = margeset.column[1];
        col_pre = margeset.column[0];
        col_index = margeset.column[2];
    }

    return {
        row: row,
        row_pre: row_pre,
        row_index: row_index,
        col: col,
        col_pre: col_pre,
        col_index: col_index,
    };
}
